import { Observable } from 'rxjs';
import { LimitModel } from '@src/core/domain/limits/limits.model';

export abstract class TransactionLimitRepository {
  abstract getLimitAccount(param: any): Observable<LimitModel>;
}
